import styles from './Title.module.css';

const Title=({text,className, ...props})=>{
    return <div className={`ng_p_1_sb ${className} ${styles.title}`} {...props}>{text}</div>
}
export default  Title
